var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2571_105160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2571_105160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34167 14.4001L6.89167 6.46676L5.575 7.03343V8.8001H4.375V6.23343L7.45833 4.93343C7.56944 4.88899 7.67778 4.85565 7.78333 4.83343C7.88889 4.81121 7.99167 4.8001 8.09167 4.8001C8.38056 4.8001 8.63611 4.86399 8.85833 4.99176C9.08056 5.11954 9.26944 5.29454 9.425 5.51676L9.575 5.73343C9.83056 6.12232 10.1167 6.53065 10.4333 6.95843C10.75 7.38621 11.3972 7.6001 12.375 7.6001V8.8001C11.6528 8.8001 11.0111 8.66676 10.45 8.4001C9.88889 8.13343 9.45833 7.76676 9.15833 7.3001L8.80833 9.2001L9.975 10.3668V14.4001H8.775V10.8168L7.55833 9.88343L6.525 14.4001H5.34167ZM9.175 4.4001C8.78611 4.4001 8.45556 4.26399 8.18333 3.99176C7.91111 3.71954 7.775 3.38899 7.775 3.0001C7.775 2.61121 7.91111 2.28065 8.18333 2.00843C8.45556 1.73621 8.78611 1.6001 9.175 1.6001C9.56389 1.6001 9.89444 1.73621 10.1667 2.00843C10.4389 2.28065 10.575 2.61121 10.575 3.0001C10.575 3.38899 10.4389 3.71954 10.1667 3.99176C9.89444 4.26399 9.56389 4.4001 9.175 4.4001Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalk);
export default __webpack_public_path__ + "static/media/walk.e004f6bf0da5ad391bda98dbf486fa6c.svg";
export { ForwardRef as ReactComponent };